import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { CollateralItemState } from '@/types';
import { useDeleteCollateralItemStateMutation } from '@/services';

export interface DeleteCollateralItemStateProps extends DialogProps {
  сollateralItemState: CollateralItemState;
  onClose(): void;
}

const DeleteCollateralItemState: React.FC<DeleteCollateralItemStateProps> = ({
  сollateralItemState,
  onClose,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCollateralItemState, deleteCollateralItemStateResponse] = useDeleteCollateralItemStateMutation();

  async function handleDeleteCollateralItemState() {
    try {
      await deleteCollateralItemState(сollateralItemState).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{сollateralItemState?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{сollateralItemState?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={deleteCollateralItemStateResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteCollateralItemStateResponse.isLoading}
          onClick={handleDeleteCollateralItemState}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCollateralItemState;
